import {
  faHouse,
  faChartLine,
  faFolderOpen,
  faClipboardQuestion,
  faCircleCheck,
  faFileExport,
  faHandshake,
  faShieldCheck,
} from "@fortawesome/pro-light-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export interface NavItem {
  label: string;
  path: string;
  icon: IconDefinition;
  id: string;
  siteAdminOnly?: boolean;
  /** Server-rendered page with no client-side route in the new-chrome roots
   *  (ProjectLayout/SettingsAppLayout). Force a full-page GET even inside a
   *  client-side-routing root, so it doesn't land on an unmatched route and
   *  render a blank content area. */
  reloadDocument?: boolean;
}

const navItems: NavItem[] = [
  {
    label: "Home",
    path: "/home",
    icon: faHouse,
    id: "nav-home",
  },
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: faChartLine,
    id: "nav-dashboard",
    // Legacy analytics dashboard: server-rendered (app_chrome layout), not a
    // React route in any chrome root — must full-page GET.
    reloadDocument: true,
  },
  {
    label: "Projects",
    path: "/projects",
    icon: faFolderOpen,
    id: "nav-projects",
  },
  {
    label: "Surveys",
    path: "/surveys",
    icon: faClipboardQuestion,
    id: "nav-surveys",
  },
  {
    label: "Approvals",
    path: "/pending_approvals",
    icon: faCircleCheck,
    id: "nav-approvals",
  },
  {
    label: "Document Deliveries",
    path: "/document_deliveries",
    icon: faFileExport,
    id: "nav-document-deliveries",
  },
  // Partner Requests — hidden until we decide whether to support this feature
  // going forward. Restore this entry to bring the nav link back.
  // {
  //   label: "Partner Requests",
  //   path: "/external_requests",
  //   icon: faHandshake,
  //   id: "nav-partner-requests",
  // },
  {
    label: "Account Health",
    path: "/account_health_snapshots",
    icon: faShieldCheck,
    id: "nav-account-health",
    siteAdminOnly: true,
  },
];

export default navItems;
